var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalCustomers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E1E8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6016 16.2011V15.4511C12.6016 14.2085 11.4502 13.2011 10.03 13.2011H9.17316C7.75296 13.2011 6.60156 14.2085 6.60156 15.4511V16.2011M13.9732 13.2011H14.83C16.2502 13.2011 17.4016 14.2085 17.4016 15.4511V16.2011M13.8016 7.90308C14.073 7.80744 14.3634 7.77828 14.6485 7.81805C14.9335 7.85782 15.2049 7.96536 15.4398 8.13165C15.6747 8.29793 15.8663 8.51812 15.9985 8.77375C16.1307 9.02937 16.1997 9.31298 16.1997 9.60078C16.1997 9.88858 16.1307 10.1722 15.9985 10.4278C15.8663 10.6834 15.6747 10.9036 15.4398 11.0699C15.2049 11.2362 14.9335 11.3437 14.6485 11.3835C14.3634 11.4233 14.073 11.3941 13.8016 11.2985M11.4016 9.60108C11.4016 10.0785 11.2119 10.5363 10.8744 10.8739C10.5368 11.2114 10.079 11.4011 9.60156 11.4011C9.12417 11.4011 8.66634 11.2114 8.32877 10.8739C7.9912 10.5363 7.80156 10.0785 7.80156 9.60108C7.80156 9.12369 7.9912 8.66585 8.32877 8.32829C8.66634 7.99072 9.12417 7.80108 9.60156 7.80108C10.079 7.80108 10.5368 7.99072 10.8744 8.32829C11.2119 8.66585 11.4016 9.12369 11.4016 9.60108V9.60108Z",
    stroke: "#3754DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalCustomers);
export default __webpack_public_path__ + "static/media/total-customers.b6abf9417b9cb43a8a6362d3b965b88b.svg";
export { ForwardRef as ReactComponent };